export default __webpack_public_path__ + "static/media/img (1).51d87da7.jpg";